import { render } from "./ScenariosSection.vue?vue&type=template&id=830e7fea"
import script from "./ScenariosSection.vue?vue&type=script&lang=js"
export * from "./ScenariosSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__